export const SKU_GENDERS_GET_REQUEST = "@skuGenders.get.request";
export const SKU_GENDERS_GET_SUCCESS = "@skuGenders.get.success";
export const SKU_GENDERS_GET_FAIL = "@skuGenders.get.failure";
